import { axiosApi } from "../../../../../api/dbAxios";

export const addFeedback = async (
  {
    category,
    text,
    code,
    case_no,
  }: {
    category?: string | null;
    text: string;
    code?: string | null;
    case_no?: string | null;
  },
  files: File[] = [],
) => {
  if (!files.length) {
    const body: any = { text, files: [] };

    if (code) body.code = code;
    if (case_no) body.case_no = case_no;
    if (category) body.category = category;

    const response = await axiosApi.post(`/feedback/`, body);
    return response.data;
  }

  const formData = new FormData();
  formData.append("text", text);

  if (code) formData.append("code", code);
  if (case_no) formData.append("case_no", case_no);
  if (category) formData.append("category", category);

  files.forEach((file) => formData.append("files", file));

  try {
    const response = await axiosApi.post(`/feedback/`, formData);
    return response.data;
  } catch (error) {
    console.error("Error sending feedback:", error);
    throw error;
  }
};
